import { Unit, UnitStatus } from './types';

const currentYear = new Date().getFullYear();

export const INITIAL_UNITS: Unit[] = Array.from({ length: 10 }, (_, i): Unit => ({
  id: `unit-${i + 1}`,
  address: `Lot #${100 + i}`,
  city: 'Sunny Meadows',
  state: 'FL',
  zip: '33544',
  status: i % 4 === 0 ? UnitStatus.VACANT : i % 7 === 0 ? UnitStatus.DELINQUENT : UnitStatus.OCCUPIED,
  monthlyRent: 850 + (i * 25),
  lastInspectionDate: new Date(2023, 11, 15 - i).toISOString().split('T')[0],
  year: 2010 + (i % 5),
  make: i % 2 === 0 ? 'Clayton' : 'Skyline',
  model: i % 2 === 0 ? 'Lakeside' : 'Grandview',
  tenantName: i % 4 === 0 ? '' : `Tenant ${i + 1}`,
  tenantPhone: i % 4 === 0 ? '' : `555-010${i}`,
  tenantEmail: i % 4 === 0 ? '' : `tenant${i+1}@example.com`,
  spouseName: i % 5 === 0 ? '' : `Spouse ${i + 1}`,
  spousePhone: i % 5 === 0 ? '' : `555-020${i}`,
  spouseEmail: i % 5 === 0 ? '' : `spouse${i+1}@example.com`,
  childrenNames: i % 3 === 0 ? 'Child A, Child B' : '',
  leaseStart: '2023-01-01',
  leaseEnd: '2028-01-01', // Target payoff date
  moveInDate: '2023-01-15',
  salesAmount: 45000 + (i * 1500),
  employmentHistory: i % 4 === 0 ? [] : [
    { 
      id: `job-${i}-1`, 
      jobName: 'Local Logistics Co.', 
      tenantName: `Tenant ${i + 1}`, 
      startDate: '2021-05-10', 
      monthlyIncome: 3200 
    }
  ],
  conditionNotes: ["Roof looks good", "AC serviced last spring"],
  communicationLog: [
    { id: `log-${i}-1`, date: '2024-01-10', note: 'Initial lease signed and security deposit received.' }
  ],
  photos: [],
  documents: [],
  taxInfo: {
    records: {
      [currentYear]: {
        payment1: { amount: 0, date: '' },
        payment2: { amount: 0, date: '' },
        comments: 'No record for current period yet.'
      }
    },
    taxWebsite: ''
  }
}));
